import { SideBarItem } from "@zapier/product-nav";
import {
  PROJECT,
  projectAssetsAtom_SUSPENDS,
  sideBarSelectedAtom,
} from "@zapier/canvas-state";
import capitalizeFirstLetter from "../../utils/capitalizeFirstLetter";
import { useAtomValue } from "jotai";
import { Suspense } from "react";

type Props = {
  handleSideBarItemPress: (name: typeof PROJECT) => void;
};

function SuspendedProjectSideBarItem({ handleSideBarItemPress }: Props) {
  const response = useAtomValue(projectAssetsAtom_SUSPENDS);
  const hasError = "error" in response;

  return (
    <SideBarItemWrapper
      handleSideBarItemPress={handleSideBarItemPress}
      status={hasError ? "warning" : undefined}
    />
  );
}

type Status = "error" | "warning" | "success" | "info" | undefined;

function SideBarItemWrapper({
  handleSideBarItemPress,
  status,
}: Props & { status?: Status }) {
  const sideBarSelected = useAtomValue(sideBarSelectedAtom);

  return (
    <SideBarItem
      name={PROJECT}
      icon="navProjects"
      tooltipTitle={capitalizeFirstLetter(PROJECT)}
      selected={sideBarSelected === PROJECT}
      onPress={() => handleSideBarItemPress(PROJECT)}
      status={status}
    />
  );
}

export default function ProjectSideBarItem({ handleSideBarItemPress }: Props) {
  return (
    <>
      <Suspense
        fallback={
          <SideBarItemWrapper handleSideBarItemPress={handleSideBarItemPress} />
        }
      >
        <SuspendedProjectSideBarItem
          handleSideBarItemPress={handleSideBarItemPress}
        />
      </Suspense>
    </>
  );
}
